import React from 'react';
import { NAV } from '../content';
import { PAGES, pathFor, isPlainClick } from '../routes';

// The four nav tabs. The original site used English-only button artwork
// (home_0.gif etc.) with the label baked into the image, so it could not be
// translated. We now render real text from NAV[lang] and style it as tabs on
// the black bar (see App.css .nav-btn) so the labels follow the language.
//
// These are anchors rather than buttons so every page has a real href that
// search engines can crawl and visitors can copy or open in a new tab.
function Nav({ page, lang, onNavigate }) {
  return (
    <nav className="nav">
      {PAGES.map((id) => {
        const active = page === id;
        return (
          <a
            key={id}
            className={`nav-btn${active ? ' active' : ''}`}
            href={pathFor(lang, id)}
            aria-current={active ? 'page' : undefined}
            onClick={(event) => {
              if (!isPlainClick(event)) return;
              event.preventDefault();
              onNavigate(lang, id);
            }}
          >
            {NAV[lang][id]}
          </a>
        );
      })}
    </nav>
  );
}

export default Nav;
